import React from 'react'
import "./ProductDetail94.css"
function ProductDetail94() {
  return (
    <>
    <div className='container-fluid p-5'>
        
    <div className='row'>
        <div className='col-12 col-sm-6 col-md-6'>
            <div>
        <img 
        src='ImagesNew/feature-fastag-LR.jpeg'
        alt='image2'
        className='solutionimg'
        />
         </div>
        </div>
        <div className='col-12 col-sm-6 col-md-6'>
            <div className='p-5'>
            <h5></h5>
         </div>
        </div>
    </div>
    </div>
    </>
  )
}

export default ProductDetail94
